import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import InstallButton from "@/components/InstallButton";
import { X, ArrowsClockwise, DownloadSimple } from "@phosphor-icons/react";

// Banner pe Dashboard: apare când admin-ul a anunțat o versiune nouă.
// Instalare/actualizare DIRECTĂ pe telefon ȘI pe PC (fără descărcare .zip):
//  - dacă aplicația nu e încă instalată → buton „Instalează aplicația" (PWA, un click).
//  - actualizarea se face direct: golește cache-urile Service Worker + reîncarcă la ultima versiune.
export default function BlingUpdateBanner() {
  const [info, setInfo] = useState(null);
  const [dismissed, setDismissed] = useState(false);
  const [busy, setBusy] = useState(false);
  const [installed, setInstalled] = useState(false);

  useEffect(() => {
    try {
      const standalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
      setInstalled(!!standalone);
    } catch (e) { /* noop */ }
    api.get("/companion/version").then((r) => setInfo(r.data)).catch(() => {});
  }, []);

  if (!info || !info.version || !info.published_at) return null;
  if (dismissed || localStorage.getItem("bling_ack_version") === info.version) return null;

  const later = () => { localStorage.setItem("bling_ack_version", info.version); setDismissed(true); };

  // Instalare directă a actualizării web (fără download) — funcționează pe telefon și PC.
  const updateWeb = async () => {
    setBusy(true);
    try {
      if ("serviceWorker" in navigator) {
        const regs = await navigator.serviceWorker.getRegistrations();
        await Promise.all(regs.map((r) => r.update().catch(() => {})));
      }
      if (window.caches) {
        const keys = await caches.keys();
        await Promise.all(keys.map((k) => caches.delete(k)));
      }
    } catch (e) { /* noop */ }
    localStorage.setItem("bling_ack_version", info.version);
    const url = window.location.pathname + "?v=" + encodeURIComponent(info.version);
    window.location.replace(url);
  };

  return (
    <div className="mb-6 flex flex-wrap items-center gap-4 rounded-xl border border-primary/40 bg-primary/[0.08] p-4" data-testid="app-update-banner">
      <DownloadSimple size={26} weight="bold" className="shrink-0 text-primary" />
      <div className="min-w-0 flex-1">
        <div className="font-head text-sm font-bold">Actualizează aplicația (v{info.version})</div>
        <p className="text-xs text-muted-foreground">
          {info.notes || "O versiune nouă este disponibilă."} Se instalează direct, fără descărcare — pe telefon și pe PC.
        </p>
      </div>
      <div className="flex items-center gap-2">
        {!installed && <InstallButton />}
        <Button size="sm" onClick={updateWeb} disabled={busy} className="gap-1.5" data-testid="app-update-install">
          <ArrowsClockwise size={16} weight="bold" /> {busy ? "Se actualizează…" : "Actualizează acum"}
        </Button>
        <button onClick={later} className="rounded-md p-1.5 text-muted-foreground hover:text-foreground" title="Mai târziu" data-testid="app-update-dismiss">
          <X size={16} />
        </button>
      </div>
    </div>
  );
}
